import { IFilters } from '@types';
import { UknownObject } from '@utils/tsUtils';

export const filtersChangeHandler =
  (
    filters: IFilters,
    attributeFilters: UknownObject<string[]>,
    setAttributeFilters: (newValue: UknownObject<string[]>) => void
  ) =>
  (name: string, value: string) => {
    if (Array.isArray(value)) {
      // handle range of values
      setAttributeFilters({ ...attributeFilters, [`${name}`]: value });
      return;
    }

    if (value === null) {
      // handle clear filter
      const att = { ...attributeFilters };
      delete att[`${name}`];
      setAttributeFilters({
        ...att,
      });
      return;
    }
    if (attributeFilters && attributeFilters.hasOwnProperty(name)) {
      if (attributeFilters[name].includes(value)) {
        if (filters.attributes[name].length === 1) {
          const att = { ...attributeFilters };
          delete att[name];
          setAttributeFilters({
            ...att,
          });
        } else {
          setAttributeFilters({
            ...attributeFilters,
            [name]: attributeFilters[name].filter((item) => item !== value),
          });
        }
      } else {
        setAttributeFilters({
          ...attributeFilters,
          [name]: [...attributeFilters[name], value],
        });
      }
    } else {
      setAttributeFilters({ ...attributeFilters, [name]: [value] });
    }
  };

export const parseQueryAttributeFilters = (
  query: string
): Record<string, string[]> => {
  const filters = {};
  if (query == null || query === '') {
    return filters;
  }

  const keyValSeparator = '_';
  const keyValSubSeparator = '--';
  const entrySeparator = '.';

  const propsWithValues = query.split(entrySeparator).filter((n) => n);
  propsWithValues.map((tuple) => {
    const propWithValues = tuple.split(keyValSeparator).filter((n) => n);
    filters[propWithValues[0]] = propWithValues
      .slice(1)
      .map((v) => v.replace(keyValSubSeparator, keyValSeparator));
  });
  return filters;
};

export const serializeQueryAttributeFilters = (
  values: Record<string, string[]>
): string => {
  const str = [];
  const keyValSeparator = '_';
  const keyValSubSeparator = '--';
  const entrySeparator = '.';
  Object.entries(values).forEach(([key, value]) => {
    str.push(
      `${key}${keyValSeparator}${value
        .map((v) => v.replace(keyValSeparator, keyValSubSeparator))
        .join(keyValSeparator)}`
    );
  });
  return str.join(entrySeparator);
};
